import React, { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';
import { useNavigate } from 'react-router-dom';

const AdminDashboard = () => {
  const [tables, setTables] = useState([]);
  const [selectedTable, setSelectedTable] = useState('');
  const [tableData, setTableData] = useState([]);
  const [editingRow, setEditingRow] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    checkAdminStatus();
    fetchTables();
  }, []);

  const checkAdminStatus = async () => {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user || user.email !== 'choudharysuryansh1111@gmail.com') {
      navigate('/');
    }
  };

  const fetchTables = async () => {
    const { data, error } = await supabase
      .from('information_schema.tables')
      .select('table_name')
      .eq('table_schema', 'public');

    if (error) {
      console.error('Error fetching tables:', error);
    } else {
      setTables(data.map(t => t.table_name));
    }
    setLoading(false);
  };

  const fetchTableData = async (tableName) => {
    setLoading(true);
    const { data, error } = await supabase
      .from(tableName)
      .select('*');

    if (error) {
      console.error(`Error fetching data from ${tableName}:`, error);
    } else {
      setTableData(data);
      setSelectedTable(tableName);
    }
    setLoading(false);
  };

  const handleEdit = (row) => {
    setEditingRow({ ...row });
  };

  const handleSave = async () => {
    setLoading(true);
    const { data, error } = await supabase
      .from(selectedTable)
      .update(editingRow)
      .eq('id', editingRow.id);

    if (error) {
      console.error('Error updating row:', error);
    } else {
      const updatedData = tableData.map(row => 
        row.id === editingRow.id ? editingRow : row
      );
      setTableData(updatedData);
    }
    setEditingRow(null);
    setLoading(false);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this row?')) {
      setLoading(true);
      const { error } = await supabase
        .from(selectedTable)
        .delete()
        .eq('id', id);

      if (error) {
        console.error('Error deleting row:', error);
      } else {
        setTableData(tableData.filter(row => row.id !== id));
      }
      setLoading(false);
    }
  };

  const handleInputChange = (e, column) => {
    setEditingRow({ ...editingRow, [column]: e.target.value });
  };

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-2xl font-bold mb-4">Admin Dashboard</h1>
      <div className="mb-4">
        <select 
          className="p-2 border rounded"
          onChange={(e) => fetchTableData(e.target.value)}
          value={selectedTable}
        >
          <option value="">Select a table</option>
          {tables.map(table => (
            <option key={table} value={table}>{table}</option>
          ))}
        </select>
      </div>
      {loading ? (
        <p>Loading...</p>
      ) : selectedTable ? (
        <table className="w-full border-collapse border">
          <thead>
            <tr>
              {tableData.length > 0 && Object.keys(tableData[0]).map(column => (
                <th key={column} className="border p-2">{column}</th>
              ))}
              <th className="border p-2">Actions</th>
            </tr>
          </thead>
          <tbody>
            {tableData.map(row => (
              <tr key={row.id}>
                {Object.entries(row).map(([column, value]) => (
                  <td key={column} className="border p-2">
                    {editingRow && editingRow.id === row.id ? (
                      <input
                        type="text"
                        value={editingRow[column]}
                        onChange={(e) => handleInputChange(e, column)}
                        className="w-full p-1 border rounded"
                      />
                    ) : (
                      value
                    )}
                  </td>
                ))}
                <td className="border p-2">
                  {editingRow && editingRow.id === row.id ? (
                    <button onClick={handleSave} className="bg-green-500 text-white px-2 py-1 rounded mr-2">Save</button>
                  ) : (
                    <button onClick={() => handleEdit(row)} className="bg-blue-500 text-white px-2 py-1 rounded mr-2">Edit</button>
                  )}
                  <button onClick={() => handleDelete(row.id)} className="bg-red-500 text-white px-2 py-1 rounded">Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>Select a table to view and edit data</p>
      )}
    </div>
  );
};

export default AdminDashboard;